import React, { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { Loader } from 'lucide-react';

const PrivateRoute: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const isAuthenticated = useSelector(
    (state: RootState) => state.app.user.isAuthenticated,
  );

  useEffect(() => {
    const checkAuth = async () => {
      await new Promise((resolve) => setTimeout(resolve, 500));
      setLoading(false);
    };

    checkAuth();
  }, [isAuthenticated]);

  if (loading) {
    return (
      <div className="relative min-h-screen flex flex-col justify-center items-center">
        <Loader className="animate-spin" size={48} />
      </div>
    );
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
